// extracted by mini-css-extract-plugin
module.exports = {"chatAssistant":"ChatAssistant_chatAssistant__BbE4c","chatAssistantButton":"ChatAssistant_chatAssistantButton__yCf57"};